import React, { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { getCalendsoPassword, selectCalendsoPassword } from '@/redux/reducers/auth.reducer'

import CalendsoPassword from '../components/CalendsoPassword'

export default function CalendsoPasswordContainer() {
  const dispatch = useAppDispatch()

  const password = useAppSelector(selectCalendsoPassword)

  useEffect(() => {
    dispatch(getCalendsoPassword())
  }, [dispatch])

  return <CalendsoPassword value={password || ''} />
}
